import { actionValues } from "@ac-expo/api-types";
import { z } from "zod";

const actionsSchema = z.enum(actionValues);

export const rightsSchema = z
  .object({
    statistics: z.array(actionsSchema),
    clientExhibitor: z.array(actionsSchema),
    clientVisitor: z.array(actionsSchema),
    clientGroup: z.array(actionsSchema),
    event: z.array(actionsSchema),
    eventMain: z.array(actionsSchema),
    eventTicketing: z.array(actionsSchema),
    eventCashRegister: z.array(actionsSchema),
    eventAccessControl: z.array(actionsSchema),
    eventExhibitor: z.array(actionsSchema),
    eventBadge: z.array(actionsSchema),
    eventInvitation: z.array(actionsSchema),
    eventSchedule: z.array(actionsSchema),
    eventFunctionality: z.array(actionsSchema),
    eventTransfer: z.array(actionsSchema),
    eventCommunicationKit: z.array(actionsSchema),
    conversation: z.array(actionsSchema),
    userAccess: z.array(actionsSchema),
  })
  .refine(
    (data) =>
      data.statistics.length > 0 ||
      data.clientExhibitor.length > 0 ||
      data.clientVisitor.length > 0 ||
      data.clientGroup.length > 0 ||
      data.event.length > 0 ||
      data.eventMain.length > 0 ||
      data.eventTicketing.length > 0 ||
      data.eventCashRegister.length > 0 ||
      data.eventAccessControl.length > 0 ||
      data.eventExhibitor.length > 0 ||
      data.eventBadge.length > 0 ||
      data.eventInvitation.length > 0 ||
      data.eventSchedule.length > 0 ||
      data.eventFunctionality.length > 0 ||
      data.eventTransfer.length > 0 ||
      data.eventCommunicationKit.length > 0 ||
      data.conversation.length > 0 ||
      data.userAccess.length > 0,
    {
      message: "Vous devez choisir au moins un droit",
    },
  );

export const defaultRightsValues = {
  statistics: [],
  clientExhibitor: [],
  clientVisitor: [],
  clientGroup: [],
  event: [],
  eventMain: [],
  eventTicketing: [],
  eventCashRegister: [],
  eventAccessControl: [],
  eventExhibitor: [],
  eventBadge: [],
  eventInvitation: [],
  eventSchedule: [],
  eventFunctionality: [],
  eventTransfer: [],
  eventCommunicationKit: [],
  conversation: [],
  userAccess: [],
};

export type RightsForm = z.infer<typeof rightsSchema>;

export const acExpoRightsSchema = z
  .object({
    acExpoDashboard: z.array(actionsSchema),
    acExpoUser: z.array(actionsSchema),
    acExpoAllEvent: z.array(actionsSchema),
    acExpoEventBeforeOnlineControl: z.array(actionsSchema),
    acExpoEventAfterVisitorCreationControl: z.array(actionsSchema),
    acExpoEventReported: z.array(actionsSchema),
    acExpoEventAfterAiCreationControl: z.array(actionsSchema),
    acExpoAllTouristicPlace: z.array(actionsSchema),
    acExpoTouristicPlaceBeforeOnlineControl: z.array(actionsSchema),
    acExpoTouristicPlaceReported: z.array(actionsSchema),
    acExpoConnectEventsData: z.array(actionsSchema),
    acExpoAccountingTicketing: z.array(actionsSchema),
    acExpoAccountingService: z.array(actionsSchema),
    acExpoAccountingPurchase: z.array(actionsSchema),
    acExpoAccountingInvoice: z.array(actionsSchema),
    acExpoAccountingClient: z.array(actionsSchema),
    acExpoAccountingCreditNote: z.array(actionsSchema),
    acExpoConversation: z.array(actionsSchema),
    acExpoUserAccess: z.array(actionsSchema),
    acExpoNotification: z.array(actionsSchema),
    acExpoSettingsStock: z.array(actionsSchema),
    acExpoSettingsDiscountCode: z.array(actionsSchema),
    acExpoSettingsFaq: z.array(actionsSchema),
    acExpoSettingsPrestation: z.array(actionsSchema),
    acExpoSettingsPayments: z.array(actionsSchema),
    acExpoSettingsStats: z.array(actionsSchema),
    acExpoRemoteControl: z.array(actionsSchema),
    acExpoReporting: z.array(actionsSchema),
    acExpoActionEmailNotification: z.array(actionsSchema),
    acExpoSettingsEventFormQuestions: z.array(actionsSchema),
    acExpoSettingsFaqChatbot: z.array(actionsSchema),
    acExpoSettingsBusinessSector: z.array(actionsSchema),
  })
  .refine(
    (data) =>
      data.acExpoDashboard.length > 0 ||
      data.acExpoUser.length > 0 ||
      data.acExpoAllEvent.length > 0 ||
      data.acExpoEventBeforeOnlineControl.length > 0 ||
      data.acExpoEventAfterVisitorCreationControl.length > 0 ||
      data.acExpoEventReported.length > 0 ||
      data.acExpoEventAfterAiCreationControl.length > 0 ||
      data.acExpoAllTouristicPlace.length > 0 ||
      data.acExpoTouristicPlaceBeforeOnlineControl.length > 0 ||
      data.acExpoTouristicPlaceReported.length > 0 ||
      data.acExpoConnectEventsData.length > 0 ||
      data.acExpoAccountingTicketing.length > 0 ||
      data.acExpoAccountingService.length > 0 ||
      data.acExpoAccountingPurchase.length > 0 ||
      data.acExpoAccountingInvoice.length > 0 ||
      data.acExpoAccountingClient.length > 0 ||
      data.acExpoAccountingCreditNote.length > 0 ||
      data.acExpoConversation.length > 0 ||
      data.acExpoUserAccess.length > 0 ||
      data.acExpoNotification.length > 0 ||
      data.acExpoSettingsStock.length > 0 ||
      data.acExpoSettingsDiscountCode.length > 0 ||
      data.acExpoSettingsFaq.length > 0 ||
      data.acExpoSettingsPrestation.length > 0 ||
      data.acExpoSettingsPayments.length > 0 ||
      data.acExpoSettingsStats.length > 0 ||
      data.acExpoRemoteControl.length > 0 ||
      data.acExpoReporting.length > 0 ||
      data.acExpoSettingsFaqChatbot.length > 0 ||
      data.acExpoActionEmailNotification.length > 0 ||
      data.acExpoSettingsEventFormQuestions.length > 0 ||
      data.acExpoSettingsBusinessSector.length > 0,
    { message: "Vous devez choisir au moins un droit" },
  );

export const defaultAcExpoRightsValues = {
  acExpoDashboard: [],
  acExpoUser: [],
  acExpoAllEvent: [],
  acExpoEventBeforeOnlineControl: [],
  acExpoEventAfterVisitorCreationControl: [],
  acExpoEventReported: [],
  acExpoEventAfterAiCreationControl: [],
  acExpoAllTouristicPlace: [],
  acExpoTouristicPlaceBeforeOnlineControl: [],
  acExpoTouristicPlaceReported: [],
  acExpoConnectEventsData: [],
  acExpoAccountingTicketing: [],
  acExpoAccountingService: [],
  acExpoAccountingPurchase: [],
  acExpoAccountingInvoice: [],
  acExpoAccountingClient: [],
  acExpoAccountingCreditNote: [],
  acExpoConversation: [],
  acExpoUserAccess: [],
  acExpoNotification: [],
  acExpoSettingsStock: [],
  acExpoSettingsDiscountCode: [],
  acExpoSettingsFaq: [],
  acExpoSettingsPrestation: [],
  acExpoSettingsPayments: [],
  acExpoSettingsStats: [],
  acExpoRemoteControl: [],
  acExpoReporting: [],
  acExpoActionEmailNotification: [],
  acExpoSettingsEventFormQuestions: [],
  acExpoSettingsFaqChatbot: [],
  acExpoSettingsBusinessSector: [],
};

export type AcExpoRightsForm = z.infer<typeof acExpoRightsSchema>;
